var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEcox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 200,
    height: 200,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#021540"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M12 18c3.402 0 6-2.597 6-6s-2.598-6-6-6s-6 2.597-6 6s2.597 6 6 6m0 1.286a7.286 7.286 0 1 0 0-14.572a7.286 7.286 0 0 0 0 14.572",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.602 17.572a5.426 5.426 0 0 0 4.826-5.336c0-2.945-2.421-5.336-5.421-5.379A7.3 7.3 0 0 0 6 8.057c.3-.06.608-.094.925-.094c2.413 0 4.372 1.911 4.372 4.273a4.32 4.32 0 0 1-4.83 4.243q.506.61 1.135 1.093"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 8.1a4.256 4.256 0 0 0-5.328 4.123a4.256 4.256 0 0 0 4.86 4.221q-.503.63-1.135 1.128a5.357 5.357 0 0 1-4.826-5.345a5.36 5.36 0 0 1 5.421-5.37Q17.567 7.424 18 8.1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.428 16.483C6.75 13.959 9.12 12 11.991 12c2.931 0 5.336 2.04 5.58 4.637a7.5 7.5 0 0 1-1.166.934q.034-.245.035-.497c0-2.228-1.993-4.028-4.449-4.028s-4.449 1.8-4.449 4.028q.001.195.022.377a7.3 7.3 0 0 1-1.136-.968"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.255 6.429c.112.342.172.702.172 1.071c0 2.164-1.985 3.913-4.427 3.913c-2.443 0-4.428-1.749-4.428-3.913q0-.491.129-.943c-.467.3-.896.656-1.273 1.046c.06 2.674 2.529 4.826 5.572 4.826c3.077 0 5.571-2.207 5.571-4.929v-.06a7.3 7.3 0 0 0-1.316-1.011"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEcox);
export default __webpack_public_path__ + "static/media/ecox.b35ed8e1f38d6674821aede9cb13f6a7.svg";
export { ForwardRef as ReactComponent };